import { useQuery } from '@apollo/client';

import type {
  GetCoursesBySlugs_Dedupe1Query,
  GetCoursesBySlugs_Dedupe1QueryVariables,
} from 'bundles/premium-hub/queries/__generated__/getCoursesBySlugs';
import type {
  GetSpecializationsBySlugs_Dedupe1Query,
  GetSpecializationsBySlugs_Dedupe1QueryVariables,
} from 'bundles/premium-hub/queries/__generated__/getSpecializationsBySlugs';
import getCoursesBySlugs from 'bundles/premium-hub/queries/getCoursesBySlugs.graphql';
import getSpecializationsBySlugs from 'bundles/premium-hub/queries/getSpecializationsBySlugs.graphql';

type data = { relatedCourses?: GetCoursesBySlugs_Dedupe1Query; relatedS12ns?: GetSpecializationsBySlugs_Dedupe1Query };

/**
 * @param courseSlugs
 * @param s12nSlugs
 * @returns
 */
const useCoursesAndSpecializations = (courseSlugs: string[], s12nSlugs: string[]): data => {
  const { data: coursesData } = useQuery<GetCoursesBySlugs_Dedupe1Query, GetCoursesBySlugs_Dedupe1QueryVariables>(
    getCoursesBySlugs,
    {
      context: { clientName: 'gatewayGql' },
      skip: !courseSlugs.length,
      variables: {
        slugs: courseSlugs,
      },
    }
  );

  const { data: s12nsData } = useQuery<
    GetSpecializationsBySlugs_Dedupe1Query,
    GetSpecializationsBySlugs_Dedupe1QueryVariables
  >(getSpecializationsBySlugs, {
    context: { clientName: 'gatewayGql' },
    skip: !s12nSlugs.length,
    variables: {
      slugs: s12nSlugs,
    },
  });

  return {
    relatedCourses: coursesData,
    relatedS12ns: s12nsData,
  };
};

export default useCoursesAndSpecializations;
